__turbopack_context__.v({
  "component": "style-module-scss-module__wZdLJa__component",
});
